









































































import {
  ApiMerchantStoreCommodityGroupListResponse,
  apiShoppingCartAdd,
} from '@/api'
import { calcSkuId, submit } from '@/utils'
import { computed, ref } from '@vue/composition-api'
import { defineClassComponent, useActivated, useMessenger } from '@/hooks'
import { instantDeliveryBus } from '../bus'
import { RequiredDeep } from 'vtils/types'
import { router } from '@/router'

type SpecList = Array<{
  /** 规格 ID */
  id: string
  /** 规格名称 */
  name: string
  /** 规格值列表 */
  values: Array<{
    /** 规格 ID */
    pid: string
    /** 规格值 ID */
    id: string
    /** 规格值名称 */
    name: string
  }>
}>

export default defineClassComponent<{
  value: boolean
  martId: string
  goods: RequiredDeep<ApiMerchantStoreCommodityGroupListResponse>[0]['commodityList'][0]
}>(
  {
    props: ['value', 'martId', 'goods'],
  },
  ({ props, ctx }) =>
    class {
      constructor() {
        useActivated(() =>
          router.beforeEach((to, from, next) => {
            this.visible.value = false
            next()
          }),
        )
      }

      visible = useMessenger(
        () => props.value,
        visible => ctx.$emit('input', visible),
      )

      selectedSku = ref<typeof props.goods['skuList'][0]>(
        props.goods.skuList.find(item => item.defaultShow === 1) ??
          props.goods.skuList[0],
      )

      specList = computed(() => {
        return props.goods.skuList.reduce<SpecList>((res, sku) => {
          sku.skuSpecs.forEach(item => {
            let specIndex = res.findIndex(x => x.id === item.skuAttributeId)
            if (specIndex === -1) {
              specIndex = res.length
              res.push({
                id: item.skuAttributeId,
                name: item.attributeName,
                values: [],
              })
            }
            const specValueIndex = res[specIndex].values.findIndex(
              x => x.id === item.selected.id,
            )
            if (specValueIndex === -1) {
              res[specIndex].values.push({
                pid: item.skuAttributeId,
                id: item.selected.id,
                name: item.selected.value,
              })
            }
          })
          return res
        }, [])
      })

      getVisibleSkuBySpecValue = (
        specValue: SpecList[0]['values'][0],
        index: number,
      ) => {
        return props.goods.skuList.find(
          sku =>
            sku.skuId ===
            calcSkuId([
              props.goods.commodityId,
              ...this.selectedSku.value.skuSpecs
                .map<string[]>((item, i) => {
                  return i === index
                    ? [specValue.pid, specValue.id]
                    : [item.skuAttributeId, item.selected.id]
                })
                .flat(),
            ]),
        )!
      }

      specValueStock = computed(() => {
        const stock: Record<string, number> = {}
        const selectedSpecValueIds = this.selectedSku.value.skuSpecs.map(
          spec => spec.selected.id,
        )
        this.specList.value.forEach((item, index) => {
          item.values.forEach(specValue => {
            if (selectedSpecValueIds.includes(specValue.id)) {
              stock[specValue.id] = this.selectedSku.value.surplusStock
            } else {
              stock[specValue.id] =
                this.getVisibleSkuBySpecValue(specValue, index)
                  ?.surplusStock || 0
            }
          })
        })
        return stock
      })

      handleSpecValueClick = (
        specValue: SpecList[0]['values'][0],
        index: number,
      ) => {
        this.selectedSku.value = this.getVisibleSkuBySpecValue(
          specValue,
          index,
        )
      }

      handleAddToCartClick = () => {
        submit(async $ => {
          $.start('加入购物车中...')
          await apiShoppingCartAdd(
            {
              commodityId: props.goods.commodityId,
              skuId: this.selectedSku.value.skuId,
              quantity: 1,
            },
            {
              businessChannel: props.martId,
            },
          )
          instantDeliveryBus.emit('refreshCart')
          await $.success('加入购物车成功')
        })
      }
    },
)
